
    var riot = require('riot')
    //src: starling/src/tags/node-attributes.html
riot.tag2('node-attributes',
  '<span each="{getAttributes()}" class="node-attribute" onpointerup="{handleClick.bind(this, id)}" oncontextmenu="{handleRightClick.bind(this, id)}" data-id="{id}"> <span class="node-attribute_key {name === \'#\' ? \'hashtag\' : \'\'}"> <raw html="{linkify(name)}"></raw> </span> <span class="node-attribute_value"> <raw html="{linkify(value)}"></raw> </span> <i if="{!canvasIsViewOnly()}" class="node-attribute_context-menu material-icons" onclick="{summonMenu.bind(this, id)}">more_vert</i> <i data-attr-id="{id}" if="{!canvasIsViewOnly()}" class="node-attribute_context-menu material-icons">more_vert</i> </span> <span if="{!canvasIsViewOnly()}" class="node-attribute_add" onpointerdown="{stopPropagation}" ontouchstart="{stopPropagation}" onclick="{handleAddAttributeClick.bind(this, null)}" data-tip="Add an attribute"> <i class="material-icons node-attribute_add_icon">add_circle</i> </span>',
  '',
  'ondblclick="{stopPropagation}" class="node-attribute_list node-attribute_list--{opts.displaystyle}"', function(opts) {
'use strict';

var _this = this;

var _appUi = require('lib/app-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkify = require('linkifyjs/html');
var parent = this.parent;
var canvas = parent.canvas;

var nodeTag = parent;
canvas.nodeAttributeTags[nodeTag.id] = this;

this.canvasIsViewOnly = function () {
  return canvas.isViewOnly();
};

this.linkify = function (input) {
  return linkify((0, _escapeHtml2.default)(input));
};

this.summonMenu = function (attributeId, e) {
  if (canvas.dragging) return;
  if (_this.canvasIsViewOnly()) return;

  if (canvas.tags['node-attribute-menu'].isOpen) {
    if (canvas.tags['node-attribute-menu'].attributeId && canvas.tags['node-attribute-menu'].attributeId !== attributeId) {
      var referenceEl = _this.root.querySelector('[data-attr-id="' + attributeId + '"]');
      canvas.tags['node-attribute-menu'].summon({
        nodeTag: nodeTag,
        attributeId: attributeId,
        referenceEl: referenceEl
      });
    } else {
      canvas.tags['node-attribute-menu'].hide();
    }
  } else {
    var _referenceEl = _this.root.querySelector('[data-attr-id="' + attributeId + '"]');
    canvas.tags['node-attribute-menu'].summon({
      nodeTag: nodeTag,
      attributeId: attributeId,
      referenceEl: _referenceEl
    });
  }
};

this.handleClick = function (attributeId, e) {
  if (e.button === 2) return;
  if (canvas.dragging) return;
  if (e.target.classList.contains('linkified')) return;
  if (_this.canvasIsViewOnly()) return;
  _this.summonMenu(attributeId, e);
};

this.handleRightClick = function (attributeId, e) {
  if (e.altKey) return;
  if (_this.canvasIsViewOnly()) return;
  e.stopPropagation();
  e.stopImmediatePropagation();
  e.preventDefault();

  canvas.rightClickMenu.summon({
    x: e.clientX,
    y: e.clientY,
    isAttribute: true,
    attributeId: attributeId,
    nodeTag: nodeTag
  });
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Card-Attribute-Right-Click',
    label: 'Open-Attribute-Menu'
  });

  if (canvas.tags['node-attribute-menu'].isOpen) {
    canvas.tags['node-attribute-menu'].hide();
  } else {
    var referenceEl = _this.root.querySelector('[data-attr-id="' + attributeId + '"]');
    canvas.tags['node-attribute-menu'].summon({
      nodeTag: nodeTag,
      attributeId: attributeId,
      referenceEl: referenceEl
    });
  }
};

this.getAttributes = function () {
  var node = canvas.store.getNode(nodeTag.id);
  if (node) return node.getAttributes();
};

this.handleAddAttributeClick = function (attributeId, e) {
  e.stopPropagation();
  canvas.hidePopups();
  _this.openAttributeEditor({ attributeId: attributeId, reset: true });
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Card-Attribute-Add-Click',
    label: 'Open-Attribute-Panel'
  });
};

this.openAttributeEditor = function (_ref) {
  var attributeId = _ref.attributeId,
      _ref$isEditing = _ref.isEditing,
      isEditing = _ref$isEditing === undefined ? false : _ref$isEditing,
      _ref$reset = _ref.reset,
      reset = _ref$reset === undefined ? false : _ref$reset;

  var referenceEl = parent.refs.container;
  if (parent.tags && parent.tags['node-attributes']) {
    referenceEl = parent.tags['node-attributes'].root;
    // don't open panel all the way off the edge of a big card
  }

  canvas.nodeAttributeEditor.summon({
    referenceEl: referenceEl,
    node: parent.instance,
    attributeId: attributeId,
    positionToLeft: _appUi.appUI.positionSubMenuToLeft({ positionReferenceElement: referenceEl }),
    isEditing: isEditing,
    reset: reset
  });
};

this.stopPropagation = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-attributes')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-attributes.html
// module id = 741
// module chunks = 0